export default __webpack_public_path__ + "static/media/BG_Short.f72fc551.png";